import React, { forwardRef } from 'react';
import { SUBSECTION_MAX_FACET_VALUES } from '../../facetsListConstants';
import SizeFacetValueSection from './sizeFacetValueSection';

const SizeFacet = forwardRef((props, ref) => {
  const { facetContainer, facetListItem } = ref;
  const {
    facet,
    isActive,
    displayFacetValues,
    uniqueFacetTitles,
    facetsByTitleGroup,
    facetContentClass,
    onFacetItemClick,
    hasAppliedFilterClass,
    facetNavigationClass,
    sizeIndicatorDisplayCallback,
  } = props;

  return (
    <li className={`${facetNavigationClass} ${hasAppliedFilterClass}`} id="size-facet-navigation" ref={facetListItem}>
      <button
        type="button"
        className="facet-header"
        onClick={() => {
          displayFacetValues();
          sizeIndicatorDisplayCallback(!facetNavigationClass.includes('active'));
        }}
        aria-controls={facet.id}
        aria-expanded={isActive}
      >
        <span className="button-content">
          {facet.name}
          <i className="fa-regular fa-chevron-down" />
        </span>
      </button>
      <div id={facet.id} className={facetContentClass} aria-hidden={!isActive}>
        {isActive && (
          <>
            <div className="facet__item-section" ref={facetContainer}>
              {facetsByTitleGroup.map((group, key) => (
                <SizeFacetValueSection
                  key={uniqueFacetTitles[key]}
                  chunkSize={SUBSECTION_MAX_FACET_VALUES}
                  facet={facet}
                  isActive={isActive}
                  sectionTitle={uniqueFacetTitles[key]}
                  onFacetItemClick={onFacetItemClick}
                  {...props}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </li>
  );
});

export default SizeFacet;
